import React from 'react';
import { MapPin, Phone, Mail, Clock, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-cream pt-20 pb-10 border-t border-charcoal-light" data-id="element-451">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-452">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-453">
          {/* Brand & Contact Info */}
          <div className="lg:col-span-1" data-id="element-454">
            <h3 className="text-3xl font-serif text-white mb-4" data-id="element-455">
              Switchplate Gallery
            </h3>
            <p className="text-warmGray-light text-base leading-relaxed mb-8" data-id="element-456">
              Handmade decorative light switch plates & outlet covers — with
              matching screws painted to match. Proudly made in the USA.
            </p>

            <div className="space-y-4 text-sm font-medium" data-id="element-457">
              <div className="flex items-start gap-3" data-id="element-458">
                <MapPin className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" data-id="element-459" />
                <span className="text-warmGray-light leading-relaxed" data-id="element-460">
                  44 Grannys Lookout Loop
                  <br data-id="element-461" />
                  Cameron, WV 26033
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-462">
                <Phone className="h-5 w-5 text-gold flex-shrink-0" data-id="element-463" />
                <div className="text-warmGray-light" data-id="element-464">
                  <a href="tel:3046863170" className="hover:text-gold transition-colors" data-id="element-465">
                    304.686.3170
                  </a>
                  <span className="mx-2 text-warmGray" data-id="element-466">|</span>
                  <a href="tel:8004976946" className="hover:text-gold transition-colors font-bold text-white" data-id="element-467">
                    800.497.6946
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-468">
                <Mail className="h-5 w-5 text-gold flex-shrink-0" data-id="element-469" />
                <a href="mailto:switchplategallery@msn.com" className="text-warmGray-light hover:text-gold transition-colors" data-id="element-470">
                  switchplategallery@msn.com
                </a>
              </div>
              <div className="flex items-center gap-3" data-id="element-471">
                <Clock className="h-5 w-5 text-gold flex-shrink-0" data-id="element-472" />
                <span className="text-warmGray-light" data-id="element-473">9AM–5PM EST</span>
              </div>
            </div>

            <div className="mt-8" data-id="element-474">
              <a href="https://www.facebook.com/switchplategallery" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-warmGray-light hover:text-gold transition-colors font-bold" data-id="element-475">
                <Facebook className="h-5 w-5" data-id="element-476" />
                <span data-id="element-477">Follow us on Facebook</span>
              </a>
            </div>
          </div>

          {/* Shop Links */}
          <div data-id="element-478">
            <h4 className="font-bold text-white mb-6 uppercase tracking-widest text-sm" data-id="element-479">
              Shop
            </h4>
            <ul className="space-y-4" data-id="element-480">
              <li data-id="element-481">
                <a href="/switchplates" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-482">
                  All Switchplates
                </a>
              </li>
              <li data-id="element-483">
                <a href="/whats-new" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-484">
                  What's New
                </a>
              </li>
              <li data-id="element-485">
                <a href="/gift-certificates" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-486">
                  Gift Certificates
                </a>
              </li>
              <li data-id="element-487">
                <a href="#/custom-orders" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-488">
                  Custom Orders
                </a>
              </li>
              <li data-id="element-489">
                <a href="/five-gang-switchplates" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-490">
                  Five Gang Switchplates
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div data-id="element-491">
            <h4 className="font-bold text-white mb-6 uppercase tracking-widest text-sm" data-id="element-492">
              Customer Service
            </h4>
            <ul className="space-y-4" data-id="element-493">
              <li data-id="element-494">
                <a href="/contact" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-495">
                  Contact Us
                </a>
              </li>
              <li data-id="element-496">
                <a href="/size-chart" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-497">
                  Size Chart
                </a>
              </li>
              <li data-id="element-498">
                <a href="/faq" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-499">
                  FAQ & "How To" Info
                </a>
              </li>
              <li data-id="element-500">
                <a href="/account" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-501">
                  My Account
                </a>
              </li>
              <li data-id="element-502">
                <a href="/cart" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-503">
                  Shopping Cart
                </a>
              </li>
              <li data-id="element-504">
                <a href="/checkout" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-505">
                  Checkout
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-506">
            <h4 className="font-bold text-white mb-6 uppercase tracking-widest text-sm" data-id="element-507">
              Company
            </h4>
            <ul className="space-y-4" data-id="element-508">
              <li data-id="element-509">
                <a href="/about" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-510">
                  About Us
                </a>
              </li>
              <li data-id="element-511">
                <a href="/mailing-list" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-512">
                  Mailing List
                </a>
              </li>
              <li data-id="element-513">
                <a href="/testimonials" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-514">
                  Testimonials
                </a>
              </li>
              <li data-id="element-515">
                <a href="/privacy" className="text-warmGray-light hover:text-gold text-base transition-colors" data-id="element-516">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-517">
          <p className="text-warmGray text-sm text-center md:text-left font-medium" data-id="element-518">
            &copy; {new Date().getFullYear()} Switchplate Gallery. All rights
            reserved. Handmade in Cameron, West Virginia.
          </p>
          <div className="flex items-center gap-4" data-id="element-519">
            <div className="flex space-x-3" data-id="element-520">
              <div className="h-8 w-12 bg-white/5 border border-white/10 rounded flex items-center justify-center text-[10px] text-warmGray-light font-bold" data-id="element-521">
                VISA
              </div>
              <div className="h-8 w-12 bg-white/5 border border-white/10 rounded flex items-center justify-center text-[10px] text-warmGray-light font-bold" data-id="element-522">
                MC
              </div>
              <div className="h-8 w-12 bg-white/5 border border-white/10 rounded flex items-center justify-center text-[10px] text-warmGray-light font-bold" data-id="element-523">
                AMEX
              </div>
              <div className="h-8 w-12 bg-white/5 border border-white/10 rounded flex items-center justify-center text-[10px] text-warmGray-light font-bold" data-id="element-524">
                DISC
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}